module.exports = __webpack_public_path__ + "static/img/img-install-tag-car-detail.e106257.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car-detail.svg
// module id = 1787
// module chunks = 1